<template>
  <div class="search-bar">
    <label-input
      class="label-input"
      label="门店名称"
      labelWidth="100px"
      placeholder="请输入门店名称"
      width="330px"
      v-model="merchantName"
      prop="merchantName"
      :input-attr="{ maxlength: 50 }"
      clearable
      valueKey="merchantName"
    />
    <el-button class="el-button--primary is-plain btn" @click="$emit('search')">查询</el-button>
  </div>
</template>

<script>
import labelInput from '@/components/global/form/labelInput';
import Fetch from '@/api';

export default {
  name: 'searchBar',
  components: {
    labelInput
  },
  props: {
    searchParams: {
      type: Object
    }
  },
  computed: {
    merchantName: {
      get() {
        return this.searchParams.merchantName;
      },
      set(val) {
        this.$emit('change', 'merchantName', val);
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  margin-bottom: 24px;

  .label-input {
    margin-right: 16px;
  }

  .btn {
    width: 80px;
  }
}
</style>
